// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__26mvL","question":"Question_question__1yWEt","description":"Question_description__1vmqm"};